import { Rule, FormInstance } from 'antd/lib/form';
import { DeviceTypeWithoutGatewayDataModel, DeviceWithoutGatewayModel } from 'core/domain/devices/models';

export const DEVICE_WITHOUT_GATEWAY_UPDATE_FORM_GENERAL_GROUP_VALUE = 1;
export const DEVICE_WITHOUT_GATEWAY_UPDATE_FORM_SENSOR_GROUP_VALUE = 2;
export const DEVICE_WITHOUT_GATEWAY_FORM_SENSOR_ROOM_KEY = 'room';
export const ONLY_NUMERIC_VALUES_REGEX = /^\d+(?:[.,]\d+)?$/;

export interface DeviceWithoutGatewayFormDataModel {
  key: string;
  title?: string;
  label: string;
  placeholder: string;
  value: string;
  units?: string;
  formGroupValue: number;
  required: boolean;
  multiple: boolean;
  type?: string;
  uuid?: string;
  id?: string;
  relatedFormKey?: string;
  rules: Rule[];
}

export interface DeviceWithoutGatewayFormLiteralsModel {
  deviceSectionTitle: string;
  sensorSectionTitle: string;
  sensorSectionDescription: string;
  requiredFieldTextLegend: string;
}

export interface DeviceWithoutGatewayFormOptionsModel {
  form: FormInstance<Record<string, string | null>>;
  formValues: DeviceWithoutGatewayFormDataModel[];
  formLiterals: DeviceWithoutGatewayFormLiteralsModel;
  deviceSectionNumber: number;
  sensorSectionNumber: number;
  onFinish: (values: Record<string, string | null>) => void;
  onFinishFailed: () => void;
}

export interface DeviceWithoutGatewayGeneralFormValuesSetModel {
  formValue: DeviceWithoutGatewayFormDataModel;
  data?: DeviceWithoutGatewayModel;
}
export interface DeviceWithoutGatewayFormValuesSetModel {
  formValue: DeviceWithoutGatewayFormDataModel;
  deviceType: DeviceTypeWithoutGatewayDataModel;
  data?: DeviceWithoutGatewayModel;
}

export enum DeviceWithoutGatewayGeneralFormValuesNames {
  NAME = 'name',
  ROOM = 'room',
  SERIAL_NUMBER = 'serial_number',
}

export enum DeviceWithoutGatewayConfigParametersFormValuesNames {
  COMMUNICATION_PLATFORM_IP = 'communication_platform_ip',
  COMMUNICATION_PLATFORM_PORT = 'communication_platform_port',
  MAIN_CONVERSION_FACTOR = 'main_conversion_factor',
  REPORTING_INTERVAL_TIME = 'reporting_interval_time',
  REPORTING_INTERVAL_NUMBER = 'reporting_interval_number',
}

export enum DeviceWithoutGatewayExtraInformationFormValuesNames {
  BUILDING_ID = 'building_id',
  SECRET_KEY = 'secret_key',
}

export enum DeviceWithoutGatewaySensorFormValuesNames {
  ACTIVE_POWER = 'active_power',
  ACTIVE_POWER_ROOM = 'active_power_room',
  ACTIVE_POWER_CH1 = 'active_power_ch1',
  ACTIVE_POWER_CH1_ROOM = 'active_power_ch1_room',
  ACTIVE_POWER_CH2 = 'active_power_ch2',
  ACTIVE_POWER_CH2_ROOM = 'active_power_ch2_room',
  ACTIVE_POWER_CH3 = 'active_power_ch3',
  ACTIVE_POWER_CH3_ROOM = 'active_power_ch3_room',
  ALARM_FLOOD = 'leakage_alarm',
  ALARM_FLOOD_ROOM = 'leakage_alarm_room',
  ALARM_TAMPER = 'tamper_alarm',
  ALARM_TAMPER_ROOM = 'tamper_alarm_room',
  BATTERY = 'battery',
  BATTERY_ROOM = 'battery_room',
  COUNT_DOWN = 'count_down',
  COUNT_DOWN_ROOM = 'count_down_room',
  COUNT_UP = 'count_up',
  COUNT_UP_ROOM = 'count_up_room',
  CURRENT = 'current',
  CURRENT_ROOM = 'current_room',
  CURRENT_CH1 = 'current_ch1',
  CURRENT_CH1_ROOM = 'current_ch1_room',
  CURRENT_CH2 = 'current_ch2',
  CURRENT_CH2_ROOM = 'current_ch2_room',
  CURRENT_CH3 = 'current_ch3',
  CURRENT_CH3_ROOM = 'current_ch3_room',
  EXPORT_KWH = 'export_kwh',
  EXPORT_KWH_ROOM = 'export_kwh_room',
  EXPORT_KWH_CH1 = 'export_kwh_ch1',
  EXPORT_KWH_CH1_ROOM = 'export_kwh_ch1_room',
  EXPORT_KWH_CH2 = 'export_kwh_ch2',
  EXPORT_KWH_CH2_ROOM = 'export_kwh_ch2_room',
  EXPORT_KWH_CH3 = 'export_kwh_ch3',
  EXPORT_KWH_CH3_ROOM = 'export_kwh_ch3_room',
  IMPORT_KWH = 'import_kwh',
  IMPORT_KWH_ROOM = 'import_kwh_room',
  IMPORT_KWH_CH1 = 'import_kwh_ch1',
  IMPORT_KWH_CH1_ROOM = 'import_kwh_ch1_room',
  IMPORT_KWH_CH2 = 'import_kwh_ch2',
  IMPORT_KWH_CH2_ROOM = 'import_kwh_ch2_room',
  IMPORT_KWH_CH3 = 'import_kwh_ch3',
  IMPORT_KWH_CH3_ROOM = 'import_kwh_ch3_room',
  PEOPLE_FLOW_IN = 'people_flow_in',
  PEOPLE_FLOW_IN_ROOM = 'people_flow_in_room',
  PEOPLE_FLOW_OUT = 'people_flow_out',
  PEOPLE_FLOW_OUT_ROOM = 'people_flow_out_room',
  POWER_FACTOR = 'power_factor',
  POWER_FACTOR_ROOM = 'power_factor_room',
  POWER_FACTOR_CH1 = 'power_factor_ch1',
  POWER_FACTOR_CH1_ROOM = 'power_factor_ch1_room',
  POWER_FACTOR_CH2 = 'power_factor_ch2',
  POWER_FACTOR_CH2_ROOM = 'power_factor_ch2_room',
  POWER_FACTOR_CH3 = 'power_factor_ch3',
  POWER_FACTOR_CH3_ROOM = 'power_factor_ch3_room',
  TOTAL_KWH = 'total_kwh',
  TOTAL_KWH_ROOM = 'total_kwh_room',
  VOLTAGE = 'voltage',
  VOLTAGE_ROOM = 'voltage_room',
  VOLTAGE_CH1 = 'voltage_ch1',
  VOLTAGE_CH1_ROOM = 'voltage_ch1_room',
  VOLTAGE_CH2 = 'voltage_ch2',
  VOLTAGE_CH2_ROOM = 'voltage_ch2_room',
  VOLTAGE_CH3 = 'voltage_ch3',
  VOLTAGE_CH3_ROOM = 'voltage_ch3_room',
}

export const CombinedDeviceWithoutGatewayFormValueNames = {
  ...DeviceWithoutGatewayGeneralFormValuesNames,
  ...DeviceWithoutGatewayExtraInformationFormValuesNames,
  ...DeviceWithoutGatewayConfigParametersFormValuesNames,
  ...DeviceWithoutGatewaySensorFormValuesNames,
} as const;

export type DeviceWithoutGatewayFormValuesNames =
  (typeof CombinedDeviceWithoutGatewayFormValueNames)[keyof typeof CombinedDeviceWithoutGatewayFormValueNames];
